query EmailTemplatePreview($input: EmailTemplateVariantInput!) {
  emailTemplatePreview(input: $input) {
    subject
    html
  }
}
